import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export abstract class LoadableState {
  @autoserializeAs('ready')
  public ready = false;
}
